import React from 'react'
import {
  CaretRight16,
  Csv32,
  Download16,
  Pdf32,
  Xls32
} from '@carbon/icons-react'
import RadioButton, { RadioButtonGroup } from '@ublique/components/RadioButton'
import Dropdown from '@ublique/components/Dropdown'
import Toggle from '@ublique/components/Toggle'

import cn from 'classnames'

const iconsMap = {
  PDF: Pdf32,
  CSV: Csv32,
  XLS: Xls32
}

function Section({ fields, title, t, type, id }) {
  const renderIcon = (icon) => {
    const Icon = iconsMap[icon]
    return <Icon className={icon} />
  }

  const renderContent = (type, props, idx) => {
    const {
      title,
      onClick,
      icon = false,
      download = false,
      currentTheme,
      themes = [],
      selectedItem,
      items,
      itemToString,
      setFormat,
      titleText,
      setWrap
    } = props
    switch (type) {
      case 'toggle':
        return (
          <div
            key={`settings-section-${idx}`}
            className='settings-section-content toggle'
          >
            {items.map(({ label, toggled, disabled, id }) => (
              <Toggle
                // labelText='Toggle element label'
                key={id}
                labelA={label}
                labelB={label}
                disabled={disabled}
                defaultToggled={toggled}
                id={`settings-toggle-${id}`}
                onToggle={(newValue) => {
                  setWrap(id, newValue)
                }}
              />
            ))}
          </div>
        )
      case 'radio':
        return (
          <div
            key={`settings-section-${idx}`}
            className='settings-section-content radio'
          >
            <h6>{title}</h6>
            <RadioButtonGroup
              legendText='Radio button heading'
              name='radio-button-group'
              defaultSelected={currentTheme}
              onChange={onClick}
            >
              {themes.map(({ id, label }) => (
                <RadioButton
                  key={`radio-btn-${id}`}
                  labelText={t(label)}
                  value={id}
                  id={id}
                />
              ))}
            </RadioButtonGroup>
          </div>
        )
      case 'dropdown':
        return (
          <div
            key={`settings-section-${idx}`}
            className='settings-section-content'
          >
            <Dropdown
              id={`setting-element-${idx}`}
              label=''
              titleText={titleText}
              selectedItem={selectedItem}
              items={items}
              itemToString={itemToString}
              onChange={({ selectedItem }) => setFormat(selectedItem)}
            />
          </div>
        )

      case 'download':
        return (
          <div
            key={`settings-section-${idx}`}
            className='settings-section-content'
            onClick={onClick}
          >
            <div className='icon-title'>
              {icon && renderIcon(icon)}
              <h6 className={cn({ withIcon: icon })}>{title}</h6>
            </div>
            {download ? <Download16 className='icon' /> : null}
          </div>
        )
      default:
        return (
          <div
            key={`settings-section-${idx}`}
            className='settings-section-content'
            onClick={onClick}
          >
            <div className='icon-title'>
              {icon && renderIcon(icon)}
              <h6 className={cn({ withIcon: icon })}>{title}</h6>
            </div>
          </div>
        )
    }
  }

  return (
    <div className='settings-section' id={id}>
      {title && <h6 className='settings-section-title'>{title}</h6>}
      {fields?.map((props, idx) => renderContent(type, props, idx))}
    </div>
  )
}

export default Section
